import { useContext } from 'react'
import ReconnectIcon from '../../icons/reconnectIcon'
import './minimizedReconnectManual.css'

import { useTranslator } from '../../translator/hook'
import { usePreviewVisible } from '../../preview/usePreviewVisible'
import { ProjectContext } from '../../project/provider'
import { isTabletSupportedMission } from '../../../utils/tabletSupportedMission'

interface MinimizedReconnectManualProps {
  connected: boolean
  hasCheckedStatus: boolean
  onTriggerDownloadTutorial?: () => void
}

export const MinimizedReconnectManual = ({
  connected,
  hasCheckedStatus,
  onTriggerDownloadTutorial,
}: MinimizedReconnectManualProps) => {
  const { t, language } = useTranslator()
  // プレビュー表示時でも、Studio 接続が必要なミッション（M2 以降）では案内を出す。
  // チュートリアル対象（rb1/rjf/rj1_trial の第 1）だけはプレビューで完結するため
  // 表示しない。
  const previewVisible = usePreviewVisible()
  const { missionInfo } = useContext(ProjectContext)
  const isPreviewCompleteMission = isTabletSupportedMission(missionInfo)
  const isVisible = hasCheckedStatus && !connected

  const onClick = () => {
    if (onTriggerDownloadTutorial) {
      setTimeout(() => {
        onTriggerDownloadTutorial()
      }, 300)
    }
  }

  if (
    !missionInfo ||
    (previewVisible && isPreviewCompleteMission) ||
    !isVisible
  ) {
    return null
  }

  return (
    <div
      className={`minimized-reconnect-manual ${isVisible ? 'show' : 'hide'}`}
      onClick={onClick}
    >
      <div className="minimized-reconnect-manual-inner">
        <span className={`minimized-reconnect-manual-inner-text-${language}`}>
          {t('how_to_reconnect')}
        </span>
        <ReconnectIcon />
      </div>
    </div>
  )
}
